import React from 'react';
import './Player.css';
import Sidebar from './Sidebar';
import Body from './Body';
import Footer from './Footer';
// import { useState, useEffect } from "react";
// import SpotifyPlayer from "react-spotify-web-playback";

function Player({spotify}) {
    return (
        <div className='player'>
            <div className='player_body'>
                <Sidebar />
                <Body spotify={spotify}/>
            </div>
            <Footer spotify={spotify} />
        </div>
    )
}

export default Player
